import { ORDER_TYPE, PAY_TYPE } from '~/api/interface';
import { IAppealStatus } from '~/api/interface/space';
import { INVOICE_TYPE, RECYCLING_BIN_MAP } from './constant';
// import { ORDER_TYPE } from '~/api';
import {
  BEHAVIOR,
  CUSTOM_COVER,
  OBJECT_TYPE,
  SITE_SEARCH_TYPE,
  TEMPLATE_SORT,
  USER_ADMIN,
  WHETHER,
} from '~/constants';

export interface DictItem {
  group?: string | number;
  key: string | number;
  label: string;
  color?: string;
  id?: string;
  children?: DictItem[];
  [key: string]: any;
}

interface DictMap {
  [key: string]: DictItem[];
}

const BASE_TAB_CONFIG = () => {
  const { $t } = useNuxtApp();
  return [
    { key: COLLECTION_MAP.OPUS, label: $t('zuo-pin') },
    { key: COLLECTION_MAP.PIECES, label: $t('cheng-pian') },
    { key: COLLECTION_MAP.PIECES_TEMPLATE, label: $t('cheng-pian-mo-ban') },
    { key: COLLECTION_MAP.SOURCE, label: $t('zi-yuan') },
  ];
};

const BASE_RESOURCE_CONFIG = () => {
  const { $t } = useNuxtApp();
  return [
    {
      label: $t('ren-wu'),
      key: RESOURCE_TYPE.PERSON,
    },
    {
      label: $t('su-cai'),
      key: RESOURCE_TYPE.MATERIAL,
    },
    {
      label: $t('zi-ti'),
      key: RESOURCE_TYPE.FONT,
    },
    {
      label: $t('yin-le'),
      key: RESOURCE_TYPE.MUSIC,
    },
    {
      label: $t('yin-xiao'),
      key: RESOURCE_TYPE.SOUND_EFFECT,
    },
    {
      label: $t('tie-zhi'),
      key: RESOURCE_TYPE.PASTER,
    },
    {
      label: $t('yan-bo-shi'),
      key: RESOURCE_TYPE_CONFIG.STUDIO,
    },
    {
      label: $t('pian-tou'),
      key: RESOURCE_TYPE.HEAD,
    },
    {
      label: $t('pian-wei'),
      key: RESOURCE_TYPE.END,
    },
  ];
};

const dict: () => DictMap = () => {
  const { $t } = useNuxtApp();
  return {
    appealStatus: [
      { key: IAppealStatus.APPEALING, label: $t('shen-su-zhong') },
      { key: IAppealStatus.APPEAL_FAIL, label: $t('shen-su-shi-bai') },
      { key: IAppealStatus.APPEAL_SUCCESS, label: $t('shen-su-cheng-gong') },
      { key: IAppealStatus.NORMAL, label: $t('wei-shen-su') },
    ],
    whether: [
      { key: WHETHER.YES, label: $t('shi') },
      { key: WHETHER.NO, label: $t('fou') },
    ],
    sorts: [
      { key: TEMPLATE_SORT.ALL, label: $t('zong-he-pai-xu') },
      // { key: TEMPLATE_SORT.NUM, label: '最多使用' },
      { key: TEMPLATE_SORT.NEW, label: $t('zui-xin-shang-xian') },
    ],
    formats: [
      { ...PLATE_TYPE_MAP()[PLATE_TYPE.HORIZONTAL], id: PLATE_TYPE.HORIZONTAL },
      { ...PLATE_TYPE_MAP()[PLATE_TYPE.VERTICAL], id: PLATE_TYPE.VERTICAL },
    ],
    updateTime: [
      { key: 'recently', label: $t('zui-jin') },
      { key: 'early', label: $t('zui-zao') },
    ],
    custumCover: [
      { key: CUSTOM_COVER.INTERCEPT, label: $t('shi-pin-jie-qu') },
      { key: CUSTOM_COVER.LOCAL, label: $t('ben-di-shang-chuan') },
    ],
    source: [
      { key: 'collection', label: $t('shou-cang') },
      { key: 'original', label: $t('yuan-chuang') },
    ],
    media: [
      { key: MEDIA_MAP.MATERIAL, label: $t('su-cai') },
      { key: MEDIA_MAP.OPENING_AND_ENDING, label: $t('pian-tou-pian-wei') },
      { key: MEDIA_MAP.TEXT_TEMPLATE, label: $t('wen-zi-mo-ban') },
      { key: MEDIA_MAP.PASTER, label: $t('tie-pian') },
      { key: MEDIA_MAP.FONT, label: $t('zi-ti') },
    ],
    collection: BASE_TAB_CONFIG(),
    // 言币消费记录
    credit_coin_consume_history: [
      { key: '0', label: $t('dang-qian-yan-bi') },
      { key: '1', label: $t('quan-bu-yan-bi') },
    ],
    resource: [
      {
        label: $t('yan-bo-shi'),
        key: RESOURCE_TYPE_CONFIG.STUDIO,
      },
      {
        label: $t('ren-wu'),
        key: RESOURCE_TYPE_CONFIG.PERSON,
      },
      {
        label: $t('yin-se'),
        key: RESOURCE_TYPE_CONFIG.TIMBRE,
      },
      {
        label: $t('zi-mu-mo-ban'),
        key: RESOURCE_TYPE_CONFIG.SUBTITLE_TEMPLATE,
      },
      {
        label: $t('wen-zi-mo-ban'),
        key: RESOURCE_TYPE.MIX_TEXT_TEMPLATE,
      },
      {
        label: $t('su-cai'),
        key: RESOURCE_TYPE_CONFIG.MATERIAL,
      },
      {
        label: $t('zi-ti'),
        key: RESOURCE_TYPE_CONFIG.FONT,
      },
      {
        label: $t('yin-le'),
        key: RESOURCE_TYPE_CONFIG.MUSIC,
      },
      {
        label: $t('yin-xiao'),
        key: RESOURCE_TYPE_CONFIG.SOUND_EFFECT,
      },
      {
        label: $t('tie-zhi'),
        key: RESOURCE_TYPE_CONFIG.PASTER,
      },
      {
        label: $t('pian-tou'),
        key: RESOURCE_TYPE_CONFIG.AE_PAG_TEMPLATE_HEAD,
      },
      {
        label: $t('pian-wei'),
        key: RESOURCE_TYPE_CONFIG.AE_PAG_TEMPLATE_TAIL,
      },
    ],
    collection_source: [
      { key: '0', label: $t('ge-ren-kong-jian') },
      { key: '1', label: $t('tuan-dui-kong-jian') },
      { key: '2', label: $t('yu-wo-fen-xiang') },
      { key: '3', label: $t('you-yan-ping-tai') },
    ],
    collection_source_person: [
      { key: '0', label: $t('ge-ren-kong-jian') },
      // { key: "1", label: "团队空间" },
      // { key: "2", label: "与我分享" },
      { key: '3', label: $t('you-yan-ping-tai') },
    ],
    collection_source_local: [
      { key: '0', label: $t('ge-ren-kong-jian') },
      { key: '1', label: $t('tuan-dui-kong-jian') },
      { key: '2', label: $t('yu-wo-fen-xiang') },
      // { key: "3", label: "有言平台" },
    ],
    roles: [
      {
        key: USER_ADMIN.ORG_ADMIN_USER,
        label: $t('qi-ye-chao-ji-guan-li-yuan'),
      },
      {
        key: USER_ADMIN.SUPER_ADMIN,
        label: $t('ping-tai-chao-ji-guan-li-yuan'),
      },
      {
        key: USER_ADMIN.MANAGEMENT_PLATFORM,
        label: $t('hou-tai-guan-li-yuan'),
      },
      { key: USER_ADMIN.NORMAL, label: $t('cheng-yuan') },
    ],
    object_type: [
      { key: OBJECT_TYPE.WORKS, label: $t('zuo-pin') },
      { key: OBJECT_TYPE.PRODUCT, label: $t('cheng-pian') },
      { key: OBJECT_TYPE.PERSON, label: $t('3d-ren-wu') },
    ],
    behavior: [
      {
        key: BEHAVIOR.CONTEXT_CREATE,
        label: $t('sheng-cheng-nei-rong-yi-jian-sheng-cheng'),
      },
      {
        key: BEHAVIOR.CONTEXT_PREVIEW,
        label: $t('3d-sheng-cheng'),
      },
      {
        key: BEHAVIOR.CONTEXT_RENDERING,
        label: $t('sheng-cheng-nei-rong-xuan-ran-shi-pin'),
      },
      {
        key: BEHAVIOR.CAMERA_CREATE,
        label: $t('bian-ji-jing-tou-yi-jian-sheng-cheng'),
      },
      { key: BEHAVIOR.CAMERA_PREVIEW, label: $t('3d-sheng-cheng') },
      {
        key: BEHAVIOR.CAMERA_RENDERING,
        label: $t('bian-ji-jing-tou-xuan-ran-shi-pin'),
      },
      { key: BEHAVIOR.EXPORT, label: $t('dao-chu-cheng-pian-shi-pin') },
      { key: BEHAVIOR.QUICKEN, label: $t('pai-dui-jia-su') },
      // { key: BEHAVIOR.AI_PROMPT, label: "AI优化prompt'" },
      { key: BEHAVIOR.AI_GEN, label: $t('aigc-sheng-cheng-jiao-ben') },
      { key: BEHAVIOR.THREE_D_PERSON, label: $t('3d-ren-wu-xuan-ran') },
    ],
    behavior_group: [
      {
        group: OBJECT_TYPE.WORKS,
        key: OBJECT_TYPE.WORKS,
        label: $t('zuo-pin'),
        children: [
          {
            key: `${BEHAVIOR.CONTEXT_CREATE},${BEHAVIOR.CAMERA_CREATE},${BEHAVIOR.CONTEXT_PREVIEW},${BEHAVIOR.CAMERA_PREVIEW}`,
            label: $t('3d-sheng-cheng'),
          },
          // {
          //   key: `${BEHAVIOR.CONTEXT_PREVIEW},${BEHAVIOR.CAMERA_PREVIEW}`,
          //   label: $t('sheng-cheng-nei-rong-yu-lan'),
          // },
          { key: BEHAVIOR.AI_GEN, label: $t('aigc-sheng-cheng-jiao-ben') },
        ],
      },
      {
        group: OBJECT_TYPE.PRODUCT,
        key: OBJECT_TYPE.PRODUCT,
        label: $t('cheng-pian'),
        children: [
          { key: BEHAVIOR.EXPORT, label: $t('dao-chu-cheng-pian-shi-pin') },
          { key: BEHAVIOR.QUICKEN, label: $t('pai-dui-jia-su') },
        ],
      },
      {
        group: OBJECT_TYPE.PERSON,
        key: OBJECT_TYPE.PERSON,
        label: $t('3d-ren-wu'),
        children: [{ key: BEHAVIOR.THREE_D_PERSON, label: $t('3d-ren-wu-xuan-ran') }],
      },
      {
        group: OBJECT_TYPE.TEXT_ON_TEXT,
        key: OBJECT_TYPE.TEXT_ON_TEXT,
        label: $t('wen-sheng-wen'),
        children: [
          { key: BEHAVIOR.CHAT_GET, label: $t('dui-hua-sheng-cheng') },
          { key: BEHAVIOR.TEXT_OPTIMIZE, label: $t('wen-an-you-hua') },
        ],
      },
    ],
    space: [
      ...BASE_TAB_CONFIG(),
      { key: COLLECTION_MAP.RECYCLING_BIN, label: $t('hui-shou-zhan') },
    ],
    shareWithMe: [
      { key: '0', label: $t('tuan-dui-kong-jian') },
      { key: '1', label: $t('yu-wo-fen-xiang') },
    ],
    share: BASE_TAB_CONFIG(),
    brand: [
      {
        key: RESOURCE_TYPE.PASTER,
        label: $t('pin-pai-logo'),
        resource_type: RESOURCE_TYPE.PASTER,
        model_type: COLLECTION_MAP.SOURCE,
        target: TARGET_FROM.Sticker,
      },
      {
        key: RESOURCE_TYPE.FONT,
        label: $t('pin-pai-zi-ti'),
        resource_type: RESOURCE_TYPE.FONT,
        model_type: COLLECTION_MAP.SOURCE,
        target: TARGET_FROM.Font,
      },
      {
        key: RESOURCE_TYPE.TEMPLATE,
        label: $t('pin-pai-mo-ban'),
        resource_type: RESOURCE_TYPE.TEMPLATE,
        model_type: COLLECTION_MAP.PIECES_TEMPLATE,
        target: TARGET_FROM.Template,
      },
      {
        key: RESOURCE_TYPE.STUDIO,
        label: $t('pin-pai-yan-bo-shi'),
        resource_type: RESOURCE_TYPE.STUDIO,
        model_type: COLLECTION_MAP.SOURCE,
        target: TARGET_FROM.Studio,
      },
      {
        key: RESOURCE_TYPE.PERSON,
        label: $t('pin-pai-ren-wu'),
        resource_type: RESOURCE_TYPE.PERSON,
        model_type: COLLECTION_MAP.SOURCE,
        target: TARGET_FROM.VirtualHuman,
      },
      {
        key: RESOURCE_TYPE.MATERIAL,
        label: $t('su-cai'),
        resource_type: RESOURCE_TYPE.MATERIAL,
        model_type: COLLECTION_MAP.SOURCE,
        target: TARGET_FROM.Material,
      },
      {
        key: RESOURCE_TYPE.MUSIC,
        label: $t('yin-le'),
        resource_type: RESOURCE_TYPE.MUSIC,
        model_type: COLLECTION_MAP.SOURCE,
        target: TARGET_FROM.BGM,
      },
      {
        key: RESOURCE_TYPE.SUBTITLE_TEMPLATE,
        label: $t('zi-mu-mo-ban'),
        resource_type: RESOURCE_TYPE.SUBTITLE_TEMPLATE,
        model_type: COLLECTION_MAP.SOURCE,
        target: TARGET_FROM.SubtitleTemplate,
      },
      {
        key: RESOURCE_TYPE.HEAD,
        label: $t('pian-tou'),
        resource_type: RESOURCE_TYPE.HEAD,
        model_type: COLLECTION_MAP.SOURCE,
        target: TARGET_FROM.Title,
      },
      {
        key: RESOURCE_TYPE.END,
        label: $t('pian-wei'),
        resource_type: RESOURCE_TYPE.END,
        model_type: COLLECTION_MAP.SOURCE,
        target: TARGET_FROM.Credit,
      },
    ],
    site: [
      {
        key: SITE_SEARCH_TYPE.ALL,
        label: $t('quan-bu'),
      },
      {
        key: SITE_SEARCH_TYPE.HIGHLIGHT,
        label: $t('chan-pin-liang-dian'),
        max: 4,
      },
      {
        key: SITE_SEARCH_TYPE.PERSON,
        label: $t('3d-shu-zi-ren'),
        max: 4,
      },
      {
        key: SITE_SEARCH_TYPE.OPUS,
        label: $t('zuo-pin'),
        max: 10,
      },
      {
        key: SITE_SEARCH_TYPE.SENSE,
        label: $t('ying-yong-chang-jing'),
        max: 2,
      },
      {
        key: SITE_SEARCH_TYPE.CASE,
        label: $t('qi-ye-an-li'),
        max: 4,
      },
      {
        key: SITE_SEARCH_TYPE.CLASS,
        label: $t('jiao-cheng'),
        max: 4,
      },
      {
        key: SITE_SEARCH_TYPE.HELP,
        label: $t('bang-zhu-zhong-xin'),
        max: 2,
      },
      {
        key: SITE_SEARCH_TYPE.SCHOOL,
        label: $t('mo-fa-xue-yuan'),
        max: 2,
      },
    ],
    foreignSite: [
      {
        key: SITE_SEARCH_TYPE.ALL,
        label: $t('quan-bu'),
      },
      {
        key: SITE_SEARCH_TYPE.HIGHLIGHT,
        label: $t('chan-pin-liang-dian'),
        max: 4,
      },
      {
        key: SITE_SEARCH_TYPE.PERSON,
        label: $t('3d-shu-zi-ren'),
        max: 5,
      },
      {
        key: SITE_SEARCH_TYPE.OPUS,
        label: $t('zuo-pin'),
        max: 10,
      },
      // {
      //   key: SITE_SEARCH_TYPE.SENSE,
      //   label: $t('ying-yong-chang-jing'),
      //   max: 2,
      // },
      // {
      //   key: SITE_SEARCH_TYPE.CASE,
      //   label: $t('qi-ye-an-li'),
      //   max: 4,
      // },
      {
        key: SITE_SEARCH_TYPE.CLASS,
        label: $t('jiao-cheng'),
        max: 5,
      },
      // {
      //   key: SITE_SEARCH_TYPE.HELP,
      //   label: $t('bang-zhu-zhong-xin'),
      //   max: 2,
      // },
      // {
      //   key: SITE_SEARCH_TYPE.SCHOOL,
      //   label: $t('mo-fa-xue-yuan'),
      //   max: 2,
      // },
    ],
    studio: [
      {
        label: $t('ding-zhi'),
        key: 'custom',
      },
      {
        label: $t('pin-pai'),
        key: 'brand',
      },
      {
        label: $t('shou-cang'),
        key: 'collection',
      },
    ],
    mediaType: [
      {
        label: $t('tu-pian'),
        key: FILE_TYPE_MAP.IMAGE,
      },
      {
        label: $t('shi-pin'),
        key: FILE_TYPE_MAP.VIDEO,
      },
      {
        label: 'PPT',
        key: FILE_TYPE_MAP.PPT,
      },
      {
        label: 'PDF',
        key: FILE_TYPE_MAP.PDF,
      },
    ],
    material: [
      {
        label: $t('yuan-chuang'),
        key: 'original',
      },
      {
        label: $t('pin-pai'),
        key: 'brand',
      },
      {
        label: $t('shou-cang'),
        key: 'collection',
      },
    ],
    equity: [
      {
        label: $t('ge-ren-ban-biao-zhun-ban'),
        key: 'personal',
      },
      {
        label: $t('qi-ye-ban'),
        key: 'enterprise',
      },
    ],
    resource_type: BASE_RESOURCE_CONFIG(),
    resource_type_team: BASE_RESOURCE_CONFIG().filter(o => o.key !== RESOURCE_TYPE.PERSON),
    recycling_bin: RECYCLING_BIN_MAP(),
    order_type: [
      { key: ORDER_TYPE.TIME, label: $t('jia-gou-shi-chang') },
      { key: ORDER_TYPE.STORAGE, label: $t('jia-gou-cun-chu') },
      { key: ORDER_TYPE.ACCOUNT, label: $t('jia-gou-zi-zhang-hao') },
      { key: ORDER_TYPE.RENDER, label: $t('jia-gou-zhuan-xian') },
      { key: ORDER_TYPE.SUBLICENSE, label: $t('jia-gou-zhuan-shou-quan') },
      { key: ORDER_TYPE.CREDITS, label: $t('jia-gou-yan-bi') },
      { key: ORDER_TYPE.ACTIVITY, label: $t('huo-dong') },
      { key: ORDER_TYPE.PACKAGE, label: $t('tao-can-gou-mai') },
    ],
    order_status: [
      { key: ORDER_STATUS.UNPAID, label: $t('wei-fu-kuan'), color: '#FFB53D' },
      { key: ORDER_STATUS.PAID, label: $t('yi-fu-kuan'), color: '#00D5A6' },
      {
        key: ORDER_STATUS.CLOSED,
        label: $t('jiao-yi-guan-bi'),
        color: '#FF5656',
      },
      {
        key: ORDER_STATUS.REFUNDED,
        label: $t('yi-tui-kuan'),
        color: '#00D5A6',
      },
      {
        key: ORDER_STATUS.FAILED,
        label: $t('zhi-fu-shi-bai'),
        color: '#FF5656',
      },
      { key: ORDER_STATUS.REVOKED, label: $t('yi-che-xiao') },
      { key: ORDER_STATUS.IN, label: $t('zhi-fu-zhong'), color: '#FFB53D' },
      { key: ORDER_STATUS.END, label: $t('jiao-yi-jie-shu') },
      { key: ORDER_STATUS.EXPIRED, label: $t('yi-guo-qi'), color: '#FF5656' },
    ],
    headEnd: [
      { label: $t('pian-tou'), key: RESOURCE_TYPE_CONFIG.AE_PAG_TEMPLATE_HEAD },
      { label: $t('pian-wei'), key: RESOURCE_TYPE_CONFIG.AE_PAG_TEMPLATE_TAIL },
    ],
    invoiceType: [
      {
        label: $t('pu-tong-fa-piao'),
        key: INVOICE_TYPE.NORMAL,
      },
      {
        label: $t('zeng-zhi-shui-zhuan-yong-fa-piao'),
        key: INVOICE_TYPE.VAT,
      },
    ],
    payTypeCN: [
      {
        label: $t('wei-xin'),
        key: PAY_TYPE.WEIXIN,
      },
      {
        label: $t('zhi-fu-bao'),
        key: PAY_TYPE.ALIPAY,
      },
      {
        label: $t('dui-gong-zhuan-zhang'),
        key: PAY_TYPE.TRANSFER,
      },
      {
        label: $t('wu-xu-fu-kuan'),
        key: PAY_TYPE.FREE,
      },
    ],
    payTypeEn: [
      {
        label: 'airwallex',
        key: PAY_TYPE.AIRWALLEX,
      },
      {
        label: 'stripe',
        key: PAY_TYPE.STRIPE,
      },
      {
        label: $t('wu-xu-fu-kuan'),
        key: PAY_TYPE.FREE,
      },
    ],
    invoiceStatus: [
      {
        label: $t('kai-piao-zhong'),
        key: INVOICE_STATUS.WAIT,
        color: '#D9D8FF',
      },
      {
        label: $t('kai-piao-wan-cheng'),
        key: INVOICE_STATUS.SUCCESS,
        color: '#BFF4E9',
      },
      {
        label: $t('kai-piao-shi-bai'),
        key: INVOICE_STATUS.FAIL,
        color: '#FFD5D5',
      },
    ],
  };
};

export const useDict = () => {
  return dict();
};

export const useDicts = (name: string) => {
  return dict()[name];
};

export const useDictsToAntd = (name: string) => {
  return dict()[name].map(item => {
    return {
      label: item.label,
      value: item.key,
      group: item.group,
      children: item.children?.map(childItem => ({
        label: childItem.label,
        value: childItem.key,
      })),
    };
  });
};

export const useDictItem = (name: string, key?: string | number) => {
  if (key === undefined) {
    return null;
  }

  const dictMap = dict()[name];
  const dictItem = dictMap?.find(item => item.key === key);
  return dictItem;
};
